import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {Location} from '@angular/common';


@Component({
  selector: 'global-multi-features',
  templateUrl: './global-multi-features.component.html',
  styleUrls: ['./global-multi-features.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GlobalMultiFeaturesComponent implements OnInit {
  public showLoader: boolean = false;
 
  public menuItems = [
    {
      'icon': '12-Currency-Wallet.png',
      'title': '30 Currency Wallet',
      'url': '',
    },
    {
        'icon': 'Reload-Any-time-Anywhere.png',
        'title': 'Reload Any time Anywhere',
        'url': '',
      },
    {
      'icon': 'App-Enabled-Card-Management.png',
      'title': 'App-enabled Card Management',
      'url': '',
    },
    {
      'icon': '7-Customer-Support.png',
      'title': '24/7 Customer service',
      'url': '',
    },
    {
      'icon': 'Real-Time-Transaction-alerts.png',
      'title': 'Real Time Transaction Alert',
      'url': '',
    },
   
    {
      'icon': 'Tap-and-Pay.png',
      'title': 'Tap & Pay Convenience',
      'url': '',
    },
    {
      'icon': 'Customizable-Spending-Limits.png',
      'title': 'Customizable Spending Limits',
      'url': '',
    },
    {
      'icon': '3D-Secure-E-Commerce-Authentication.png',
      'title': '3D Secure E-Commerce Authentication',
      'url': '',
    },
    {
      'icon': 'Card-Insurance-Coverage-up-to-5-Lakhs.png',
      'title': 'Card Insurance Coverage up to ₹5 Lakhs',
      'url': '',
    },
    
  ];
  public Items = [
    {
      'icon': 'benefit1.png',
      'title': 'International Sim',
      'url': 'esim',
    },
    {
        'icon': 'benefit2.png',
        'title': 'Free ISIC Card',
        'url': 'isicCard',
      },
      {
        'icon': 'benefit3.png',
        'title': 'International Lounge Access',
        'url': 'lounge-access',
      },
];

  constructor(
    public router: Router,
    public toast: ToastrService,
    private _location: Location
   
  ) { }

  ngOnInit() {
    this.getProfileList();
  }

  goToNewCard() {
    this.router.navigate(['/newcard']);
  }

  getProfileList() {
   
  }

 

  proceedToNextPage(pageUrl) {
    this.router.navigate([pageUrl]);
  }

  goToFeatures(singleItem) {
    // console.log("single ITEM === == ",singleItem);
    // if(singleItem.url == 'esim' || singleItem.url == 'lounge-access') {
      // this.toast.error('Coming soon!');
    // } else {
      this.router.navigate([singleItem.url]);
    // }

  }

  goToBackPage() {
    this._location.back();
  }
  
}
